(function ($) {
    GetVolunteerOpportunities = function (selector, options) {
        this.settings = $.extend({}, $.fn.getVolunteerOpportunities.defaults, options);
        this.message = {
            search: symphony.strings['layout.findOpportunitiesNear'],
            searching: symphony.strings['layout.searchingForOpportunitiesNear'],
            found: function (count) {
                return symphony.strings['layout.weFound'] + ' ' + count + ' ' + (count == 1 ? symphony.strings['layout.opportunityNear'] : symphony.strings['layout.opportunitiesNear']);
            }
        }
        this.icon = {
            size: new google.maps.Size(24, 39),
            url: '/templates/symphony/static_resources/images/global/location-pin.svg'
        };
        this.hoverIcon = {
            size: new google.maps.Size(24, 39),
            url: '/templates/symphony/static_resources/images/global/location-pin-active.svg'
        };
        this.activeIcon = {
            size: new google.maps.Size(24, 39),
            url: '/templates/symphony/static_resources/images/global/location-pin-active.svg'
        };
        this.months = [symphony.strings['layout.january'], symphony.strings['layout.february'], symphony.strings['layout.march'], symphony.strings['layout.april'], symphony.strings['layout.may'], symphony.strings['layout.june'], symphony.strings['layout.july'], symphony.strings['layout.august'], symphony.strings['layout.september'], symphony.strings['layout.october'], symphony.strings['layout.november'], symphony.strings['layout.december']];
        this.monthAbbrs = [symphony.strings['layout.jan'], symphony.strings['layout.feb'], symphony.strings['layout.mar'], symphony.strings['layout.apr'], symphony.strings['layout.may'], symphony.strings['layout.jun'], symphony.strings['layout.jul'], symphony.strings['layout.aug'], symphony.strings['layout.sep'], symphony.strings['layout.oct'], symphony.strings['layout.nov'], symphony.strings['layout.dec']];

        // default search to site zip
        this.defaultSearch = {
            text: typeof siteAddress != "undefined" && typeof siteAddress.zip != "undefined" ? siteAddress.zip : (typeof symphony != "undefined" && typeof symphony.siteSettings != "undefined" && typeof symphony.siteSettings.data != "undefined" && typeof symphony.siteSettings.data.zip != "undefined" ? symphony.siteSettings.data.zip : null),
            lat: typeof siteAddress != "undefined" && typeof siteAddress.lat != "undefined" ? siteAddress.lat : (typeof symphony != "undefined" && typeof symphony.siteSettings != "undefined" && typeof symphony.siteSettings.data != "undefined" && typeof symphony.siteSettings.data.lat != "undefined" ? symphony.siteSettings.data.lat : null),
            lng: typeof siteAddress != "undefined" && typeof siteAddress.long != "undefined" ? siteAddress.long : (typeof symphony != "undefined" && typeof symphony.siteSettings != "undefined" && typeof symphony.siteSettings.data != "undefined" && typeof symphony.siteSettings.data.long != "undefined" ? symphony.siteSettings.data.long : null)
        };
        this.search = {
            text: this.defaultSearch.text,
            lat: null,
            lng: null,
            centerLat: null,
            centerLng: null,
            miles: 13,
            addressInfo: null
        };

        var range = this.getWeekRange(new Date());
        this.startDate = range.start;
        this.endDate = range.end;

        this.map = null;
        this.currentBounds = null;
        this.prevZindex = null;
        this.locations = [];
        this.markers = [];

        this.$context = $(selector);
        this.$status = this.$context.find('.volunteerOpportunities-status').eq(0);
        this.$input = this.$context.find('input.u-siteSearch-input').eq(0);
        this.$geocodeUserLocation = this.$context.find('.u-siteSearch-geocode').eq(0);
        this.$geocodeUserNudge = this.$context.find('.u-siteSearch-geocode-nudge').eq(0);
        this.$button = this.$context.find('i.u-siteSearch-input').eq(0);
        this.$map = this.$context.find('.volunteerOpportunities-map').eq(0);
        this.$datepicker = this.$context.find('.volunteerOpportunities-datepicker').eq(0);
        this.$locations = this.$context.find('.volunteerOpportunities-locationList').eq(0);
        this.$toolbar = this.$context.find('.volunteerOpportunities-toolbar');
        this.$shiftCount = this.$toolbar.find('.volunteerOpportunities-shiftCount');
        this.$signUp = this.$toolbar.find('.btn');

        this.api = {
            getLocations: volunteerApiUrl + '/Registration/api/Assignments/GetPublicLocations', // requires zip & miles
            getAssignments: volunteerApiUrl + '/Registration/api/Assignments/GetPublicAssignments', // requires locationId
            logEvent: volunteerApiUrl + '/Framework/api/Logging/LogPageView'
        };
        this.gettingData = false;
        this.loaded = false;
        this.currentLocationId = null;
        this.selectedLocationShiftDayIds = [];
    };
    $.fn.getVolunteerOpportunities = function (param) {
        if (typeof this.data("getVolunteerOpportunities_obj") == "undefined") {
            var _ft = new GetVolunteerOpportunities(this, param);
            if (volunteerApiUrl && volunteerSiteUrl && volunteerApiUrl.length > 0 && volunteerSiteUrl.length > 0) {
                _ft.init();
            } else {
                $('.volunteerOpportunities').remove();
            }

            this.data("getVolunteerOpportunities_obj", _ft);
        } else {
            var _ft = this.data("getVolunteerOpportunities_obj");

            if (param == "destroy") {
                this.removeData("getVolunteerOpportunities_obj");
                this.unbind();
                return true;
            } else {
                if (_ft[param])
                    return _ft[param].apply(_ft, Array.prototype.slice.call(arguments, 1));
                else if (typeof param == "undefined")
                    _ft.performSearch();
                else
                    throw 'GETVOLUNTEEROPPORTUNITIES_METHOD_NOT_FOUND';
            }
        }
    };

    GetVolunteerOpportunities.prototype.init = function () {
        var self = this;

        if (!symphony || !symphony.strings || !Handlebars.helpers['getSymphonyString']) {
            setTimeout(function() {
                self.init();
            }, 1000);
            return;
        }

        self.logEvent('Load');

        if (navigator.geolocation) {
            self.$geocodeUserLocation.addClass('shown');
        }

        if (!$('body').hasClass('admin-body') && window.localStorage && localStorage.getItem('volunteeropportunities-search') !== null) {
            self.defaultSearch = JSON.parse(localStorage.getItem('volunteeropportunities-search'));
            self.search.text = JSON.parse(localStorage.getItem('volunteeropportunities-search')).text;
            self.search.lat = JSON.parse(localStorage.getItem('volunteeropportunities-search')).lat;
            self.search.lng = JSON.parse(localStorage.getItem('volunteeropportunities-search')).lng;
        }

        self.map = new GMaps({
            div: '#' + self.$map.attr('id'),
            lat: Number(self.defaultSearch.lat),
            lng: Number(self.defaultSearch.lng),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: 11
        });

        self.renderDatepicker();
        self.registerControls();
    };

    GetVolunteerOpportunities.prototype.registerControls = function () {
        var self = this;

        self.$button.on('click', function () {
            self.performSearch();
        });

        self.$input.on('keypress', function (e) {
            e = e || window.event;
            if (e.which == 13) {
                self.performSearch();
            }
        });

        self.$geocodeUserLocation.on('click', function () {
            self.useUsersLocation();
        });

        self.map.addListener('dragstart', function () {
            mapMoving();
        });

        self.map.addListener('zoom_changed', function () {
            mapMoving();
        });

        function mapMoving() {
            self.clearActiveLocation();
            if (!self.locations) {
                self.currentBounds = null;
            }
            killTimeout();
        }

        function startTimeout() {
            killTimeout();
            if (!self.gettingData) {
                self.dragTimeout = setTimeout(function () {
                    var coords = self.map.getCenter();
                    self.search.centerLat = coords.lat();
                    self.search.centerLng = coords.lng();
                    self.performSearch();
                }, 1000);
            }
        }

        function killTimeout() {
            if (self.dragTimeout !== null) {
                clearTimeout(self.dragTimeout);
                self.dragTimeout = null;
            }
        }

        self.map.addListener('idle', function () {
            if (!self.loaded) {
                self.currentBounds = self.map.getBounds();
                self.performSearch();
                self.loaded = true;
            } else if (self.currentLocationId === null) {
                self.clearActiveLocation();
                var c = self.map.getCenter();
                self.prevView = {
                    center: {
                        lat: c.lat(),
                        lng: c.lng()
                    },
                    zoom: self.map.getZoom()
                };
                var b = self.map.getBounds();
                if (!self.currentBounds || ((!self.currentBounds.contains(b.getNorthEast()) || !self.currentBounds.contains(b.getSouthWest())) && JSON.parse(JSON.stringify(self.currentBounds)) !== JSON.parse(JSON.stringify(b)))) {
                    self.currentBounds = b;
                    startTimeout();
                } else if (!self.gettingData) {
                    self.loadMarkersInView();
                }
            }
        });

        self.$locations[0].addEventListener("click", locationItemListener, true);

        function locationItemListener(event) {
            self.clearActiveLocation();

            var element = event.target;
            if (element.classList.contains('location-item-cont')) {
                self.setActiveLocation(element.parentNode);
            } else if (element.parentNode.classList.contains('location-item-cont')) {
                self.setActiveLocation(element.parentNode.parentNode);
            }
        }

        self.$datepicker.on('click', '.datepicker-prev', function () {
            self.startDate.setDate(self.startDate.getDate() - 7);
            self.endDate.setDate(self.endDate.getDate() - 7);
            self.renderDatepicker();
            self.performSearch();
        });

        self.$datepicker.on('click', '.datepicker-next', function () {
            self.startDate.setDate(self.startDate.getDate() + 7);
            self.endDate.setDate(self.endDate.getDate() + 7);
            self.renderDatepicker();
            self.performSearch();
        });

        self.$datepicker.on('click', '.datepicker-month:not(.isActive)', function () {
            var range = self.getWeekRange(this.dataset.date);
            self.startDate = range.start;
            self.endDate = range.end;
            self.renderDatepicker();
            self.performSearch();
        });

        self.$context.on('click', '.assignment-time input', function (e) {
            var id = this.value.toString();
            if (self.selectedLocationShiftDayIds.indexOf(id) > -1) {
                self.logEvent('Unselect LocationShiftDay', id);
                self.selectedLocationShiftDayIds = $.grep(self.selectedLocationShiftDayIds, function (x) {
                    return x != id;
                });
            } else {
                self.logEvent('Select LocationShiftDay', id);
                self.selectedLocationShiftDayIds.push(id);
            }
            self.$shiftCount.text(self.selectedLocationShiftDayIds.length);
            if (self.selectedLocationShiftDayIds.length > 0) {
                self.$toolbar.addClass('shown');
            } else {
                self.$toolbar.removeClass('shown');
            }
        });

        self.$signUp.on('click', function () {
            self.signUp();
        });
    };

    GetVolunteerOpportunities.prototype.getWeekRange = function (date) {
        if (new Date(date) < new Date()) {
            date = new Date();
        }
        var d = new Date(date);
        var day = d.getDay();
        var diff = d.getDate() - day;
        var range = {
            start: new Date(d.setDate(diff)),
            end: new Date((new Date(date)).setDate(diff + 6)) // end date is 6 days out (1 week total)
        };
        return range;
    };

    GetVolunteerOpportunities.prototype.getMonthByIndex = function (index, abbreviate) {
        if (index > 11) {
            index = index - 12;
        }
        if (index < 0) {
            index = index + 12;
        }
        if (abbreviate) {
            return this.monthAbbrs[index];
        }
        return this.months[index];
    };

    GetVolunteerOpportunities.prototype.numberWithSuffix = function (num) {
        var numStr = num.toString();
        switch (numStr) {
            case '11' || '12' || '13':
                return numStr + (siteLanguage == 'en' ? '<sub>th</sub>' : '');
            default:
                switch (numStr[numStr.length - 1]) {
                    case '1':
                        return numStr + (siteLanguage == 'en' ? '<sub>st</sub>' : '');
                    case '2':
                        return numStr + (siteLanguage == 'en' ? '<sub>nd</sub>' : '');
                    case '3':
                        return numStr + (siteLanguage == 'en' ? '<sub>rd</sub>' : '');
                    default:
                        return numStr + (siteLanguage == 'en' ? '<sub>th</sub>' : '');
                }
        }
    };

    GetVolunteerOpportunities.prototype.renderDatepicker = function () {
        var self = this;

        var weekText = self.getMonthByIndex(self.startDate.getMonth()) + ' ' + self.numberWithSuffix(self.startDate.getDate()) + ' - ' + self.numberWithSuffix(self.endDate.getDate());
        // if months are different, specify the month with each day
        if (self.startDate.getMonth() != self.endDate.getMonth()) {
            weekText = self.getMonthByIndex(self.startDate.getMonth(), true) + ' ' + self.numberWithSuffix(self.startDate.getDate()) + ' - ' + self.getMonthByIndex(self.endDate.getMonth(), true) + ' ' + self.numberWithSuffix(self.endDate.getDate());
        }

        self.$datepicker.html(symphony.templates['volunteerOpportunities-datepicker']({
            prevMonth: self.endDate.getMonth() == 0 ? '12/1/' + (self.endDate.getFullYear() - 1) : self.endDate.getMonth() + '/1/' + self.endDate.getFullYear(),
            prevMonthText: self.endDate.getMonth() > (new Date()).getMonth() || self.endDate.getFullYear() > (new Date()).getFullYear() ? self.getMonthByIndex(self.endDate.getMonth() - 1) : '',
            currentMonthText: self.getMonthByIndex(self.endDate.getMonth()),
            nextMonth: self.endDate.getMonth() == 11 ? '1/1/' + (self.endDate.getFullYear() + 1) : self.endDate.getMonth() + 2 + '/1/' + self.endDate.getFullYear(),
            nextMonthText: self.getMonthByIndex(self.endDate.getMonth() + 1),
            weekText: weekText,
            showPrev: self.startDate > new Date()
        }))
    };

    GetVolunteerOpportunities.prototype.loadMarkersInView = function () {
        var self = this;

        var b = self.map.getBounds();
        var locs = [];
        if (self.locations) {
            for (var i = 0; i < self.locations.length; i++) {
                if (b.contains({
                        lat: self.locations[i].locationLat,
                        lng: self.locations[i].locationLong
                    })) {
                    locs.push(self.locations[i]);
                }
            }
        }
        self.renderLocations(locs);
    };

    GetVolunteerOpportunities.prototype.renderLocations = function (locations) {
        var self = this;
        locations = locations || self.locations;

        if (typeof locations == "undefined" || locations == null) {
            locations = [];
        }

        if (self.$status.length > 0) {
            self.$status.html(self.message.found(locations.length));
        }

        self.markers = [];
        self.map.removeMarkers();

        self.$locations.html('');

        var locationList = '';
        _.forEach(locations, function (l, i) {
            l.locationAddress2 = l.locationAddress2 === null || l.locationAddress2 === '' ? '' : ' ' + l.locationAddress2;
            var addr = l.locationAddress1 + l.locationAddress2 + ', ' + l.locationCity + ', ' + l.locationState + ' ' + l.locationZip;
            var marker = self.map.addMarker({
                lat: l.locationLat,
                lng: l.locationLong,
                title: l.locationName,
                click: function (e) {
                    if (self.currentLocationId !== l.locationId) {
                        for (var i = 0; i < self.map.markers.length; i++) {
                            self.map.markers[i].setIcon(self.icon);
                        }
                        this.setIcon(self.activeIcon);
                        if (self.$context.find('.location-item.isActive').length > 0) {
                            self.$context.find('.location-item.isActive').removeClass('isActive');
                        }
                        self.$context.find('.location-item-' + l.locationId).addClass('isActive');
                        var scrollDist = self.$context.find('.location-item-' + l.locationId).position().top + (!$('body').hasClass('admin-body') ? self.$context.find('.volunteerOpportunities-locationList').scrollTop() : 0);
                        // because of the datepicker, there's 100px of overlap on desktop
                        if ($(window).width() >= 992) {
                            scrollDist = scrollDist - 91;
                        }
                        if (scrollDist < 0) {
                            scrollDist = 0;
                        }
                        self.$context.find('.volunteerOpportunities-locationList').animate({
                            scrollTop: scrollDist
                        });
                        self.currentLocationId = l.locationId;
                    }
                },
                icon: self.icon
            });
            google.maps.event.addListener(marker, 'mouseover', function () {
                marker.setIcon(self.hoverIcon);
                self.prevZindex = marker.getZIndex();
                marker.setOptions({
                    zIndex: 100000
                });
            });
            google.maps.event.addListener(marker, 'mouseout', function () {
                if (self.currentLocationId !== l.locationId) {
                    marker.setIcon(self.icon);
                    marker.setOptions({
                        zIndex: self.prevZindex
                    });
                } else {
                    marker.setIcon(self.activeIcon);
                }
            });
            self.markers.push({
                id: l.locationId,
                marker: marker
            });

            locationList += symphony.templates['volunteerOpportunities-location']({
                location: l,
                address: addr
            });
        });

        if (locations.length === 0) {
            locationList = '<p><b>' + symphony.strings['layout.noResultsFound'] + '</b></p><p>' + symphony.strings['layout.pleaseSearchAnotherLocation'] + '</p>';
        }
        self.$locations.html(locationList);

        self.getAssignments(locations);
    };

    GetVolunteerOpportunities.prototype.setActiveLocation = function (elm) {
        var self = this;

        var id = elm.dataset.id;
        var markerInst = $.grep(self.markers, function (m) {
            return m.id === id;
        })[0];

        if (markerInst) {
            var marker = markerInst.marker;

            var pos = marker.getPosition();
            self.map.setCenter(pos.lat(), pos.lng());

            self.map.setZoom(15);
            self.currentLocationId = id;

            for (var i = 0; i < self.map.markers.length; i++) {
                self.map.markers[i].setIcon(self.icon);
            }
            marker.setIcon(self.activeIcon);
            self.prevZindex = marker.getZIndex();
            marker.setOptions({
                zIndex: 100000
            });

            elm.classList.add('isActive');
        } else {
            DN.Utils.ShowStatus(symphony.strings['layout.anErrorHasOccurredPleaseTryAgain'], 5000, true);
        }
    };

    GetVolunteerOpportunities.prototype.clearActiveLocation = function () {
        var self = this;
        self.currentLocationId = null;
        if (self.$context.find('.location-item.isActive').length > 0) {
            self.$context.find('.location-item.isActive').removeClass('isActive');
        }
        for (var i = 0; i < self.map.markers.length; i++) {
            self.map.markers[i].setIcon(self.icon);
            self.map.markers[i].setOptions({
                zIndex: self.prevZindex
            });
        }
    };

    GetVolunteerOpportunities.prototype.getAssignments = function (locations) {
        var self = this;
        self.gettingData = true;

        var promises = [];
        for (var i = 0; i < locations.length; i++) {
            promises.push(getAssignment(locations[i]));
        }

        function getAssignment(location) {
            var params = {
                locationId: location.locationId,
                fromDate: self.startDate < new Date((new Date()).toShortDateString()) ? self.parseDate(new Date()) : self.parseDate(self.startDate),
                thruDate: self.parseDate(self.endDate)
            };
            return $.ajax({
                type: 'POST',
                url: self.api.getAssignments,
                contentType: 'application/json',
                data: JSON.stringify(params),
                success: function (data) {
                    data = typeof data == "string" ? JSON.parse(data) : data;

                    var assignments = data.retVal;
                    if (typeof assignments == "undefined" || assignments == null) {
                        assignments = [];
                    }

                    var $locationItem = self.$context.find('.location-item-' + location.locationId);
                    var $assList = $locationItem.find('.location-item-shifts');

                    var assignmentList = '';
                    var lastDate = null;
                    for (var i = 0; i < assignments.length; i++) {
                        var ass = assignments[i];
                        if (lastDate !== ass.day) {
                            if (lastDate != null) {
                                assignmentList += '</div></div>'; // end assignment-times
                            }
                            lastDate = ass.day;
                            assignmentList += '<div class="assignment-day"><b>' + (new Date(ass.day)).toShortDateString(true) + '</b><div class="assignment-times">';
                        }

                        assignmentList += '<div class="assignment-time">\
                            <span>' + self.formatTime(ass.startMinuteOfDay.totalMinutes) + ' - ' + self.formatTime(ass.endMinuteOfDay.totalMinutes) + '</span>\
                            <input type="checkbox" value="' + ass.locationShiftDayId + '" id="' + ass.locationShiftDayId + '" ' + (self.selectedLocationShiftDayIds.indexOf(ass.locationShiftDayId.toString()) > -1 ? 'checked="checked"' : '') + '>\
                            <label for="' + ass.locationShiftDayId + '"><span>' + symphony.strings['layout.select'] + '</span><span>' + symphony.strings['layout.selected'] + '</span></label>\
                        </div>';

                        if (i == assignments.length - 1) {
                            assignmentList += '</div></div>'; // end assignment-times
                        }
                    }
                    if (assignments.length === 0) {
                        assignmentList = '<p><b>' + symphony.strings['layout.noResultsFound'] + '</b><br>' + symphony.strings['layout.pleaseSearchAnotherLocation'] + '</p>';
                    }
                    $assList.html(assignmentList);
                    $assList.removeClass('local-loading');
                }
            });
        }

        Promise.all(promises)
            .then(function () {
                self.gettingData = false;
            });
    };

    GetVolunteerOpportunities.prototype.performSearch = function () {
        var self = this;
        self.$status.html(self.message.search);
        self.$geocodeUserNudge.removeClass('shown');

        // set the zip from the input if the search is different
        if (self.$input.length > 0 && self.$input.val().trim().length > 0 && self.search.text != self.$input.val().trim()) {
            self.search.text = self.$input.val().trim();
            self.search.lat = null;
            self.search.lng = null;
            self.search.centerLat = null;
            self.search.centerLng = null;
            self.search.addressInfo = null;
            self.currentBounds = null;
        }
        // if it's an empty string, set it to null
        if (self.search.text != null && self.search.text.trim().length === 0) {
            self.search.text = self.defaultSearch.text;
            self.search.lat = null;
            self.search.lng = null;
        }

        if (self.search.text != null) {

            self.logEvent('Search', self.search.text);

            self.search.miles = 13;
            var bounds = self.map.getBounds();
            if ((self.search.lat === null || self.search.lng === null) && (self.search.centerLat === null || self.search.centerLng === null)) {
                self.search.lat = null;
                self.search.lng = null;
                self.search.centerLat = null;
                self.search.centerLng = null;
                self.search.addressInfo = null;
            } else {
                self.search.centerLat = self.search.centerLat === null ? self.search.lat : self.search.centerLat;
                self.search.centerLng = self.search.centerLng === null ? self.search.lng : self.search.centerLng;

                if (self.search.centerLat !== null && self.search.centerLng !== null) {
                    self.map.setCenter({
                        lat: self.search.centerLat,
                        lng: self.search.centerLng
                    });
                }

                var center = bounds.getCenter();
                var ne = bounds.getNorthEast();

                // r = radius of the earth in statute miles
                var r = 3963.0;

                // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
                var lat1 = center.lat() / 57.2958;
                var lon1 = center.lng() / 57.2958;
                var lat2 = ne.lat() / 57.2958;
                var lon2 = ne.lng() / 57.2958;

                // distance = circle radius from center to Northeast corner of bounds
                var dis = r * Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));
                dis = Math.ceil(dis) - 2;
                dis = dis < 3 ? 3 : dis;

                self.search.miles = Math.ceil(dis) - 2;
            }

            // set the input from the zip
            if (self.$input.length > 0 && self.$input.val().trim().length === 0) {
                self.$input.val(self.search.text);
            }

            self.$context.addClass('local-loading');
            self.$status.html(self.message.searching);

            if (self.search.lat == null || self.search.lng == null) {
                self.geocode(function () {
                    self.getLocations();
                });
            } else {
                self.getLocations();
            }
        }
    };

    GetVolunteerOpportunities.prototype.getLocations = function () {
        var self = this;
        self.gettingData = true;

        var params = {
            address1: null,
            address2: null,
            city: null,
            stateId: null,
            zip: null,
            miles: self.search.miles,
            startDate: self.startDate < new Date((new Date()).toShortDateString()) ? self.parseDate(new Date()) : self.parseDate(self.startDate),
            endDate: self.parseDate(self.endDate),
            latitude: self.search.lat === null ? self.search.centerLat : self.search.lat, // search lat
            longitude: self.search.lng === null ? self.search.centerLng : self.search.lng, // search lng
            centerLatitude: self.search.centerLat === null ? self.search.lat : self.search.centerLat, // map pan lat
            centerLongitude: self.search.centerLng === null ? self.search.lng : self.search.centerLng // map pan lng
        };
        if (self.search.addressInfo && self.search.addressInfo.components) {
            var c = self.search.addressInfo.components;
            if (c.house_number || c.road) {
                params.address1 = [c.house_number || '', c.road || ''].join(' ');
            }
            if (c.city || c.hamlet || c.municipality) {
                params.city = c.city || c.hamlet || c.municipality;
            }
            if (c.state_code) {
                params.stateId = c.state_code;
            }
            if (c.postcode) {
                params.zip = c.postcode;
            }
        }

        $.ajax({
            type: 'POST',
            url: this.api.getLocations,
            contentType: 'application/json',
            data: JSON.stringify(params),
            success: function (d) {
                self.$context.removeClass('local-loading');

                if (typeof d.retVal != "undefined") {
                    d = d.retVal;
                }

                self.locations = d.locations;

                if (self.search.centerLat === null || self.search.centerLng === null) {
                    self.search.lat = d.latitude;
                    self.search.lng = d.longitude;
                    self.search.centerLat = d.latitude;
                    self.search.centerLng = d.longitude;

                    self.map.setCenter(self.search.lat, self.search.lng);
                    self.map.setZoom(11);
                }

                if (!$('body').hasClass('admin-body') && window.localStorage) {
                    localStorage.setItem('volunteeropportunities-search', JSON.stringify(self.search));
                }

                self.loadMarkersInView();

                // compensate for setCenter and setZoom animations
                setTimeout(function () {
                    self.gettingData = false;
                }, 300);

                self.clearActiveLocation();
                self.$context.find('.volunteerOpportunities-locationList').scrollTop(0);
            }
        });
    };

    GetVolunteerOpportunities.prototype.geocode = function (callback) {
        var self = this;
        self.gettingData = true;

        // geocode search text
        $.ajax({
            url: '//api.opencagedata.com/geocode/v1/json?q=' + self.search.text + '&countrycode=us&key=' + openCageApiKey,
            success: function (retVal) {
                self.gettingData = false;
                if (retVal.results.length > 0) {

                    // if non-numeric search, loop through results to try and match city
                    // fixes issue of matching county first
                    if (isNaN(self.search.text)) {
                        for (var i = 0; i < retVal.results.length; i++) {
                            if (self.search.lat == null || self.search.lng == null) {
                                //if (retVal.results[i] && retVal.results[i].components && retVal.results[i].components.city && self.search.text.toLowerCase().indexOf(retVal.results[i].components.city.toLowerCase()) > -1) {
                                self.search.lat = retVal.results[i].geometry.lat;
                                self.search.lng = retVal.results[i].geometry.lng;
                                self.search.addressInfo = retVal.results[i];
                                //}
                            }
                        }
                    }
                    if (self.search.lat == null || self.search.lng == null) {
                        self.search.lat = retVal.results[0].geometry.lat;
                        self.search.lng = retVal.results[0].geometry.lng;
                        self.search.addressInfo = retVal.results[0];
                    }

                }

                if (self.search.lat == null || self.search.lng == null) {
                    self.$context.removeClass('local-loading');
                    // $('#' + id).find('.mapControl-error').show();
                    return;
                }

                if (typeof callback == "function") {
                    callback();
                }
            }
        });
    };

    GetVolunteerOpportunities.prototype.useUsersLocation = function () {
        var self = this;
        self.$geocodeUserNudge.removeClass('shown');

        if (navigator.geolocation) {
            var nudgeTimeoutId = setTimeout(function () {
                self.$geocodeUserNudge.addClass('shown');
                self.$context.removeClass('local-loading');
            }, 5000);

            var geoSuccess = function (position) {
                self.$geocodeUserNudge.removeClass('shown');
                self.$geocodeUserLocation.addClass('shown');
                // We have the location, don't display banner
                clearTimeout(nudgeTimeoutId);

                // reverse geocode to get zip for search
                $.ajax({
                    url: '//api.opencagedata.com/geocode/v1/json?q=' + position.coords.latitude + ',' + position.coords.longitude + '&key=' + openCageApiKey,
                    success: function (retVal) {
                        if (retVal.results.length > 0) {
                            var loc = retVal.results[0].components;
                            self.$input.val(loc.postcode);
                            self.performSearch();
                        }
                    }
                });
            };
            var geoError = function (error) {
                switch (error.code) {
                    case error.TIMEOUT:
                        // The user didn't accept the callout
                        self.$geocodeUserNudge.addClass('shown');
                        self.$context.removeClass('local-loading');
                        break;
                }
            };

            self.$context.addClass('local-loading');
            navigator.geolocation.getCurrentPosition(geoSuccess, geoError);

        } else {
            self.$geocodeUserLocation.removeClass('shown');
        }
    };

    GetVolunteerOpportunities.prototype.signUp = function () {
        if (this.selectedLocationShiftDayIds.length > 0) {
            var c = this.map.getCenter();
            this.logEvent('Request Shifts', this.selectedLocationShiftDayIds.join(','));
            window.open(volunteerSiteUrl + '?LocationShiftDayId=' + this.selectedLocationShiftDayIds.join(',') + '&MapSearchText=' + this.search.text + '&MapCenterLat=' + c.lat() + '&MapCenterLng=' + c.lng() + '&MapZoom=' + this.map.getZoom() + '&ReferringSiteUrl=' + escape(window.location.href));
        }
    };

    GetVolunteerOpportunities.prototype.logEvent = function (name, value) {
        name = name || '';
        value = value || '';
        if (this.api.logEvent.indexOf('https://') == 0 || this.api.logEvent.indexOf(window.location.protocol) == 0) {
            try {
                var browser = window.navigator.userAgent;
                try {
                    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
                    // Firefox 1.0+
                    var isFirefox = typeof InstallTrigger !== 'undefined';
                    // Safari 3.0+ "[object HTMLElementConstructor]" 
                    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
                        return p.toString() === "[object SafariRemoteNotification]";
                    })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    // Internet Explorer 6-11
                    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
                    // Edge 20+
                    var isEdge = !isIE && !!window.StyleMedia;
                    // Chrome 1 - 79
                    var isChrome = !!window.chrome && !!window.chrome.loadTimes;
                    // Edge (based on chromium) detection
                    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

                    if (isOpera) {
                        browser = 'Opera';
                    }
                    if (isFirefox) {
                        browser = 'Firefox';
                    }
                    if (isSafari) {
                        browser = 'Safari';
                    }
                    if (isIE) {
                        browser = 'Internet Explorer';
                    }
                    if (isEdge) {
                        browser = 'Edge';
                    }
                    if (isChrome) {
                        browser = 'Chrome';
                    }
                    if (isEdgeChromium) {
                        browser = 'Edge Chromium';
                    }
                } catch (e) {
                    console.log('LOG ERROR', e);
                }

                $.ajax({
                    type: 'POST',
                    url: this.api.logEvent,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        pageName: document.title,
                        referrer: document.referrer,
                        browserType: browser,
                        isMobile: document.querySelector('html').classList.contains('touchevents') && $(window).width() <= 768,
                        eventTime: (new Date()).toISOString().replace('Z', '') + '+00:00',
                        generic1: name,
                        generic2: value,
                        generic3: window.location.href
                    })
                });
            } catch (e) {
                console.log('LOG ERROR', e);
            }
        }
    };

    GetVolunteerOpportunities.prototype.parseDate = function (date) {
        return date.toISOString().split('T')[0];
    };

    GetVolunteerOpportunities.prototype.formatTime = function (totalMinutes) {
        var minutes = parseInt(totalMinutes % 60, 10)
        var hours = parseInt(totalMinutes / 60 % 24, 10);
        var ext = hours < 12 ? "am" : "pm";
        minutes = "" + minutes;
        if (hours == 0) hours = 12;
        if (hours > 12) hours = hours - 12;
        if (minutes.length == 1) minutes = "0" + minutes;

        return hours + ":" + minutes + " " + ext;
    };

    $.fn.getVolunteerOpportunities.defaults = {};
})(jQuery);
